import { Typography } from "@mui/material";
import React from "react";

export default function TextTotalBalance({
  type = "add",
  amount = "0",
  large = false,
  ...restProps
}) {
  return (
    <Typography variant="body2" color="#BFBFBF" {...restProps}>
      <Typography variant="caption" fontSize={large ? 14 : 12} fontWeight={700}>
        ${Number(amount).toLocaleString("en-US")}
        &nbsp;
      </Typography>
      <Typography variant="caption" fontSize={large ? 14 : 12}>
        USD
      </Typography>
    </Typography>
  );
}
